import { useMemo } from "react";
import { useRoutes as renderRoutes } from "react-router-dom";

import MainRoutes from "@/routes/MainRoutes";



const useRoutes = () => {


    const routes = useMemo(() => {
        return [...MainRoutes];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return renderRoutes(routes);
};

export default useRoutes;
